<template>
  <div class="xv_view" id="Reports">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Reports</label>
      </div>
      <div class="xv_actions"></div>
    </div>
    <div class="row analyis_preview">
      <div class="col-4">
        <div class="report_preview_card">
          <label>Trace</label>
          <div class="info">
            <span>
              In ut mollis dolor. Donec mattis dui sit amet odio ultricies
              ullamcorper. Sed a ante auctor nisl malesuada posuere. In commodo
              elementum neque, in ultrices massa sollicitudin eget.
            </span>
          </div>
          <div class="footer">
            <button>Start</button>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="report_preview_card">
          <label>Declarations</label>
          <div class="info">
            <span>
              In ut mollis dolor. Donec mattis dui sit amet odio ultricies
              ullamcorper. Sed a ante auctor nisl malesuada posuere.
            </span>
          </div>
          <div class="footer">
            <button>Download</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reports",
  data() {
    return {};
  }
};
</script>
